import { render, staticRenderFns } from "./reactionRecords.vue?vue&type=template&id=5875da36&scoped=true"
import script from "./reactionRecords.vue?vue&type=script&lang=js"
export * from "./reactionRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875da36",
  null
  
)

export default component.exports